module.exports = __webpack_public_path__ + "img/about-m-slide-5.d986a0ee.jpg";